import { Space, Typography } from "antd";
import { DefaultButton } from "components/Shared/DefaultButton";
import { DefaultModal } from "components/Shared/DefaultModal";
import { useState } from "react";
import { useIntl } from "react-intl";

type Props = {
  disabled: boolean;
  count: number;
  onDelete: () => void;
};

export const DeleteWithConfirmationButton = ({ disabled, count, onDelete }: Props) => {
  const { formatMessage } = useIntl();
  const [open, setOpen] = useState(false);

  const onButtonClick = () => {
    setOpen(true);
  };

  const onModalClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Space>
        <DefaultButton disabled={disabled} type="default" onClick={onButtonClick}>
          {formatMessage({ id: "button.delete" })}
        </DefaultButton>
        <Typography.Text>{formatMessage({ id: "selectedItems" }, { count })}</Typography.Text>
      </Space>
      <DefaultModal
        title={formatMessage({ id: "deleteConfirmationModal.content" }, { count })}
        open={open}
        width={undefined}
        onOk={onDelete}
        okText={formatMessage({ id: "button.delete" })}
        onCancel={onModalClose}
      />
    </>
  );
};
